import { SceneComponentConstants } from "../../sceneComponent";
import { PostProcessRenderPipelineManager } from "./postProcessRenderPipelineManager";
import { Scene } from "../../scene";
Object.defineProperty(Scene.prototype, "postProcessRenderPipelineManager", {
    get: function () {
        if (!this._postProcessRenderPipelineManager) {
            // Register the G Buffer component to the scene.
            var component = this._getComponent(SceneComponentConstants.NAME_POSTPROCESSRENDERPIPELINEMANAGER);
            if (!component) {
                component = new PostProcessRenderPipelineManagerSceneComponent(this);
                this._addComponent(component);
            }
            this._postProcessRenderPipelineManager = new PostProcessRenderPipelineManager();
        }
        return this._postProcessRenderPipelineManager;
    },
    enumerable: true,
    configurable: true
});
/**
 * Defines the Render Pipeline scene component responsible to rendering pipelines
 */
var PostProcessRenderPipelineManagerSceneComponent = /** @class */ (function () {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */
    function PostProcessRenderPipelineManagerSceneComponent(scene) {
        /**
         * The component name helpfull to identify the component in the list of scene components.
         */
        this.name = SceneComponentConstants.NAME_POSTPROCESSRENDERPIPELINEMANAGER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */
    PostProcessRenderPipelineManagerSceneComponent.prototype.register = function () {
        this.scene._gatherRenderTargetsStage.registerStep(SceneComponentConstants.STEP_GATHERRENDERTARGETS_POSTPROCESSRENDERPIPELINEMANAGER, this, this._gatherRenderTargets);
    };
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */
    PostProcessRenderPipelineManagerSceneComponent.prototype.rebuild = function () {
        if (this.scene._postProcessRenderPipelineManager) {
            this.scene._postProcessRenderPipelineManager._rebuild();
        }
    };
    /**
     * Disposes the component and the associated ressources
     */
    PostProcessRenderPipelineManagerSceneComponent.prototype.dispose = function () {
        if (this.scene._postProcessRenderPipelineManager) {
            this.scene._postProcessRenderPipelineManager.dispose();
        }
    };
    PostProcessRenderPipelineManagerSceneComponent.prototype._gatherRenderTargets = function () {
        if (this.scene._postProcessRenderPipelineManager) {
            this.scene._postProcessRenderPipelineManager.update();
        }
    };
    return PostProcessRenderPipelineManagerSceneComponent;
}());
export { PostProcessRenderPipelineManagerSceneComponent };
//# sourceMappingURL=postProcessRenderPipelineManagerSceneComponent.js.map